import clsx from 'clsx';
import type { SyncStatus } from '../lib/sync';

/** 🟢 online · 🟠 offline (n.º por enviar) · 🔴 problema — sempre visível (proposta §3, operador). */
export function StatusPill({ sync }: { sync: SyncStatus | null }) {
  if (!sync) return null;
  const pending = sync.pending ? ` · ${sync.pending} por enviar` : '';
  if (sync.error) return <Pill tone="bad" title={sync.error}>Erro na sincronização{pending}</Pill>;
  if (!sync.online) return <Pill tone="warn">Sem rede — as vendas ficam guardadas{pending}</Pill>;
  if (sync.review) return <Pill tone="bad">{sync.review} documento(s) para rever</Pill>;
  // O browser pode apagar os dados deste terminal se faltar espaço (AUD-23): com vendas por enviar, diz-se.
  if (sync.pending && sync.storageProtected === false) {
    return <Pill tone="warn" title="Instale a aplicação (menu do browser → Instalar) para o browser não apagar os dados deste terminal por falta de espaço.">Online{pending} · instale a aplicação para proteger as vendas</Pill>;
  }
  return <Pill tone="ok" pulse={sync.syncing}>{sync.syncing ? 'A sincronizar…' : `Online${pending}`}</Pill>;
}

function Pill({ tone, title, pulse, children }: { tone: 'ok' | 'warn' | 'bad'; title?: string; pulse?: boolean; children: React.ReactNode }) {
  return (
    <span role="status" title={title} className={clsx('inline-flex h-8 shrink-0 items-center gap-2 rounded-full px-3 text-sm font-medium', {
      'bg-green-50 text-green-800 dark:bg-green-950 dark:text-green-200': tone === 'ok',
      'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-100': tone === 'warn',
      'bg-red-50 text-red-800 dark:bg-red-950 dark:text-red-200': tone === 'bad',
    })}>
      <span aria-hidden className={clsx('h-2 w-2 rounded-full', { 'bg-green-500': tone === 'ok', 'bg-amber-500': tone === 'warn', 'bg-red-500': tone === 'bad' }, pulse && 'animate-pulse')} />
      {children}
    </span>
  );
}
